import React, { useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  MessageSquare, 
  FileText,
  Bot,
  Settings
} from 'lucide-react';
import Chat from './components/Chat';
import ProjectManagement from './components/ProjectManagement';

const App: React.FC = () => {
  const [isConnected, setIsConnected] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const navigationTabs = [
    {
      path: '/',
      label: 'Chat',
      icon: MessageSquare, 
             description: 'Talk with Sair'
    },
    { 
      path: '/projects',
      label: 'Projects',
      icon: FileText, 
      description: 'Manage tasks & projects'
    }
  ];

  const currentTab = navigationTabs.find(tab => tab.path === location.pathname) || navigationTabs[0];

  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col">
        {/* Header */}
        <motion.header 
          initial={{ y: -100 }}
          animate={{ y: 0 }}
        className="glass-effect p-3 border-b border-modern-700/50 relative z-50"
        >
          <div className="flex items-center justify-between max-w-6xl mx-auto">
            <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center shadow-lg">
                <Bot className="w-6 h-6 text-white" />
              </div>
              <div>
                             <h1 className="text-xl font-bold text-white tracking-tight">Sair</h1>
                <div className="flex items-center space-x-2">
                <div className={`w-2 h-2 rounded-full shadow-lg ${isConnected ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`}></div>
                                         <span className="text-sm text-white/90 font-medium">
                           {isConnected ? 'Online' : 'Disconnected'}
                  </span>
              </div>
            </div>
          </div>

          {/* Navigation Tabs */}
            <div className="flex items-center space-x-2">
            {navigationTabs.map((tab) => (
              <motion.button
                key={tab.path}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate(tab.path)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 font-medium ${
                  location.pathname === tab.path
                    ? 'bg-primary-500/20 border border-primary-400/50 text-white'
                    : 'bg-modern-700/30 hover:bg-modern-700/50 border border-transparent text-white/70 hover:text-white'
                }`}
              >
                <tab.icon className="w-4 h-4" />
                <span className="hidden sm:inline">{tab.label}</span>
              </motion.button>
            ))}
          </div>

          <div className="flex items-center space-x-3">
            <button className="p-3 bg-modern-700/50 hover:bg-modern-700/70 text-white rounded-xl transition-all duration-200 hover:shadow-lg border border-modern-600/50">
                <Settings className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.header>

      {/* Main Content */}
      <div className="relative z-10 flex-1">
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Chat />} />
            <Route path="/projects" element={<ProjectManagement />} />
          </Routes>
            </AnimatePresence>
      </div>
    </div>
  );
};

export default App; 
